import baseTheme from 'ui/Theme/themeObject.base'

const INITIAL_MODE = 'dark'
export default {
  ...baseTheme,
  // @ts-ignore `baseTheme.colors.modes` actually exists. Trying to fix this opens a pandoras box of issues with typing because of
  // the way in which emotion and theme-ui handle theming & typing.
  colors: { ...baseTheme.colors.modes[INITIAL_MODE], ...baseTheme.colors },
}
